import { useOutletContext } from "react-router";
import { ManuellRegistreringContextType } from "./ManuellRegistreringsflyt";

export function useManuellRegistreringContext() {
  return useOutletContext<ManuellRegistreringContextType>();
}
